module.exports = __webpack_public_path__ + "img/assets/curveline--post-index.svg";